import React, { useState } from "react";
import "../../styles/DocumentViewerModal.css";

// The document (PDF or image) is served from the BFF on a DIFFERENT origin
// (app-{env}.horne-dev.com) than the SPA (<vanity>-{env}.horne-dev.com), and
// the BFF 302-redirects to a cross-origin blob SAS URL. Chrome's Opaque
// Response Blocking (ORB) blocks such cross-origin no-cors responses from being
// delivered to <embed>/<img>/<object> subresource elements — the request fires
// and even returns 200 application/pdf, but the browser discards the body with
// net::ERR_BLOCKED_BY_ORB, so the element renders as an instant broken object.
// Frame navigations are NOT subject to ORB, so we render the document in an
// <iframe>; the browser's built-in viewer handles both PDFs and images.
// On load we try to inject CSS to constrain any <img> inside the iframe.
// Cross-origin iframes (BFF → SAS redirect) block contentDocument access with
// a SecurityError, which we catch silently — PDFs are unaffected either way.
const IMG_CSS = `
  body { margin: 0; background: #f3f4f6; }
  img { max-width: 100%; max-height: 100vh; object-fit: contain; display: block; margin: auto; }
`;

const injectIframeStyles = (iframe) => {
  try {
    const doc = iframe.contentDocument;
    if (!doc || !doc.head) return;
    const style = doc.createElement('style');
    style.textContent = IMG_CSS;
    doc.head.appendChild(style);
  } catch {
    // cross-origin — cannot access contentDocument
  }
};

const DocumentViewerModal = ({ fileUrl, documentName, onClose }) => {
  const [maximized, setMaximized] = useState(false);

  if (!fileUrl) return null;

  return (
    <div className={`doc-modal-overlay${maximized ? " doc-modal-overlay--max" : ""}`}>
      <div className={`doc-modal${maximized ? " doc-modal--max" : ""}`}>

        <div className="doc-modal-header">
          <div className="doc-title">
            <span>📄</span>
            <span className="file-name">
              {documentName || "Document"}
            </span>
          </div>

          <div className="doc-modal-actions">
            <button
              type="button"
              className="doc-modal-icon-btn"
              onClick={() => setMaximized((prev) => !prev)}
              title={maximized ? "Restore" : "Maximize"}
            >
              {maximized ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M8 3v3a2 2 0 0 1-2 2H3" />
                  <path d="M21 8h-3a2 2 0 0 1-2-2V3" />
                  <path d="M3 16h3a2 2 0 0 1 2 2v3" />
                  <path d="M16 21v-3a2 2 0 0 1 2-2h3" />
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M8 3H5a2 2 0 0 0-2 2v3" />
                  <path d="M21 8V5a2 2 0 0 0-2-2h-3" />
                  <path d="M3 16v3a2 2 0 0 0 2 2h3" />
                  <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
                </svg>
              )}
            </button>

            <button
              type="button"
              className="doc-modal-icon-btn"
              onClick={onClose}
              title="Close"
            >
              ✕
            </button>
          </div>
        </div>

        <div className="doc-modal-body">
          <iframe
            src={fileUrl}
            title={documentName || "Document"}
            className="doc-modal-content"
            onLoad={(e) => injectIframeStyles(e.target)}
          />
        </div>

      </div>
    </div>
  );
};

export default DocumentViewerModal;
